import React from 'react';
import { Skeleton, Space } from 'antd';

export const ReviewSkeleton = () => {
  return (
    <div className="bg-white border rounded-lg p-4 !w-full shadow" data-testid="review-skeleton-container">
      <Space direction="vertical" size="large" className="!w-full">
        {/* Header Row */}
        <div className="flex justify-between" data-testid="review-skeleton-header">
          {/* Left: Avatar + Name + Role */}
          <div className="flex gap-4" data-testid="review-skeleton-profile">
            <Skeleton.Avatar active size="large" shape="circle" />

            <Space direction="vertical" size={8} className="pt-1">
              <Skeleton.Input active size="small" className="!w-40" />
              <Skeleton.Input active size="small" className="!w-28" />
            </Space>
          </div>

          {/* Right: Report badge */}
          <Skeleton.Button active size="small" className="!w-24" />
        </div>

        {/* Review text */}
        <Space direction="vertical" size={8} className="!w-full">
          <Skeleton.Input active size="small" className="!w-full" />
          <Skeleton.Input active size="small" className="!w-[90%]" />
          <Skeleton.Input active size="small" className="!w-[80%]" />
          <Skeleton.Input active size="small" className="!w-24" />
        </Space>

        {/* Footer Row */}
        <div className="flex justify-between items-center" data-testid="review-skeleton-footer">
          {/* Submitted date */}
          <Skeleton.Input active size="small" className="!w-32" />

          {/* Stars */}
          <div className="flex gap-1" data-testid="review-skeleton-rating">
            {[...Array(5)].map((_, i) => (
              <Skeleton.Avatar
                key={i}
                active
                shape="square"
                size="small"
                className="!w-4 !h-4"
              />
            ))}
          </div>
        </div>
      </Space>
    </div>
  );
};
